import adminAvatarSrc from '@/assets/images/admin-avatar.webp';

/** The signed-in admin's avatar (Figma 1683:589940 / 1683:591423) — one fixed illustration, shared
 *  by the sidebar chip and Edit Profile, until the backend supplies a real profile image. Exported
 *  at 188px so the 94px Edit Profile avatar stays sharp on 2× screens. */
export const ADMIN_AVATAR_SRC = adminAvatarSrc;
